import React from "react";
import styled from "@emotion/styled";
import g from "glamorous";
import { css } from "glamor";
import Layout from "../../components/layout";
import Menu from "../../components/Menu-en";
import Footer from "../../components/Footer-en";
import { Link } from "gatsby";
import { Container, Row, Col } from "glamorous-grid";
import { Helmet } from "react-helmet";
import { FaHome } from "react-icons/fa";

export default function Techniques({
  data, // this prop will be injected by the GraphQL query below.
}) {
  // data.markdownRemark holds our post data

  const mediaQueries = {
    phone: "@media only screen and (max-width: 991px)",
  };

  const WhiteRow = g.section({
    backgroundColor: `white`,
    padding: `2em 0`,
    borderBottom: `1px solid #e9eaeb`,
  });

  const GreyRow = g.section({
    backgroundColor: `#f6f7f8`,
    padding: `2em 0`,
    borderBottom: `1px solid #e9eaeb`,
  });

  const H1 = g.h1({
    fontSize: `2.9em`,
    letterSpacing: `.08em`,
    fontWeight: `600`,
    marginTop: `2em`,
    color: `#3c4d68`,
    margin: `40px 0 .3em`,
    [mediaQueries.phone]: {
      fontSize: `2.4em`,
    },
  });

  const Subtitle = g.div({
    color: `#3c4d68`,
    fontWeight: `600`,
    fontSize: `1.1em`,
    letterSpacing: `.03em`,
    marginBottom: `.5em`,
    cursor: `default`,
  });

  const Trier = styled.span`
    @media (max-width: 678px) {
      font-size: 0.75em;
      display: block;
      text-align: center;
    }
  `;

  const Selector = styled.div`
    display: inline;
    padding-left: 5px;
    @media (max-width: 678px) {
      display: block;
      padding-left: 0px;
      font-size: 0.9em;
      text-align: center;
      font-weight: 700;
      letter-spacing: -0.01em;
      margin-top: -3px;
    }
  `;

  const StyledLink = styled(Link)`
    color: #3c4d68;
    opacity: 0.55;
    :hover {
      opacity: 1;
    }
    position: relative;
    text-decoration: none;
    ::before {
      content: "";
      position: absolute;
      width: 100%;
      height: 3px;
      border-radius: 4px;
      background-color: #3c4d68;
      bottom: -5px;
      left: 0;
      transform-origin: right;
      transform: scaleX(0);
      transition: transform 0.3s ease-in-out;
    }
    :hover::before {
      transform-origin: left;
      transform: scaleX(1);
    }
  `;

  const H2 = g.h2({
    fontVariant: `small-caps`,
    fontSize: `1.8em`,
    letterSpacing: `.1em`,
    fontWeight: `500`,
    margin: `0 0 .6em`,
  });

  const cssLink = css({
    color: `#2c2e31`,
    textDecoration: `none`,
    fontSize: `1em`,
    borderBottom: `none`,
    transition: `all .3s`,
    padding: `0 0 4px 0`,
    lineHeight: `30px`,
    margin: `0`,
    position: `relative`,
    "::before": {
      content: " ",
      position: `absolute`,
      width: `100%`,
      height: `1px`,
      bottom: `0`,
      left: `0`,
      backgroundColor: `#2c2e31`,
      visibility: `invisible`,
      transform: `scaleX(0)`,
      transition: `all 0.3s ease-in-out 0s`,
    },
    ":hover": {
      transition: `all .3s`,
      border: `none`,
      background: `none`,
      padding: `0 0 3px 0`,
      margin: `0`,
      "::before": {
        visibility: `visible`,
        transform: `scaleX(1)`,
        transition: `all 0.3s ease-in-out 0s`,
      },
    },
  });

  const cssLinkTitle = css({
    color: `#3c4d68`,
    textDecoration: `none`,
    fontSize: `1em`,
    borderBottom: `none`,
    transition: `all .3s`,
    padding: `0 0 4px 0`,
    lineHeight: `30px`,
    margin: `0`,
    position: `relative`,
    "::before": {
      content: " ",
      position: `absolute`,
      width: `100%`,
      height: `3px`,
      bottom: `0`,
      left: `0`,
      backgroundColor: `#3c4d68`,
      visibility: `invisible`,
      transform: `scaleX(0)`,
      transition: `all 0.3s ease-in-out 0s`,
    },
    ":hover": {
      transition: `all .3s`,
      border: `none`,
      background: `none`,
      padding: `0 0 4px 0`,
      margin: `0`,
      "::before": {
        visibility: `visible`,
        transform: `scaleX(1)`,
        transition: `all 0.3s ease-in-out 0s`,
      },
    },
  });

  const Breadcrumb = g.ul({
    fontSize: `13px`,
    lineHeight: `20px`,
    marginLeft: `0 !important`,
    marginTop: `0`,
    marginBottom: `10px !important`,
    fontWeight: `500`,
    letterSpacing: `.015em`,
  });

  const BreadcrumbItem = g.li({
    display: `inline`,
    "&:first-of-type": {
      "&::before": {
        content: `none`,
      },
    },
    "&::before": {
      content: `/`,
      padding: `0 .5em`,
    },
  });

  const cssBreadcrumbLink = css({
    color: `#3c4d68`,
    borderBottom: `none`,
  });

  return (
    <Layout>
      <g.Div id="page-wrap" margin={`0 auto`} backgroundColor={`#fcfcfc`}>
        <Helmet>
          <title>
            Procedures of aesthetic medicine and cosmetic surgery | Dr Cédric
            Kron
          </title>
          <meta
            name="description"
            content="Procedures of aesthetic medicine and plastic surgery performed by Dr Kron in Paris : surgical lifts, botox and filler injections, breast surgery, fat removal technics."
          />
          <html lang="en" />
          <link
            rel="alternate"
            hreflang="fr"
            href="https://www.dr-kron.com/techniques/"
          />
          <script type="application/ld+json">{` {
          "@context": "http://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [{
          "@type": "ListItem",
          "position": 1,
          "name": "Procedures",
          "item": "https://www.dr-kron.com/en/procedures/"
          }]
              }
    `}</script>
        </Helmet>
        <Menu current="interventions" pathFr="/techniques/" />
        <main data-pagefind-body data-pagefind-weight="2">
          <WhiteRow css={{ paddingBottom: `20px !important` }}>
            <Container>
              <Row>
                <Col>
                  <Breadcrumb
                    css={{
                      marginTop: `3em !important`,
                      "@media only screen and (max-width: 600px)": {
                        display: `none`,
                      },
                    }}
                  >
                    <BreadcrumbItem>
                      <Link to="/en/" {...cssBreadcrumbLink} title="Homepage">
                        <FaHome
                          css={{
                            fontSize: `1.2em`,
                            paddingBottom: `.2em`,
                            transform: `translateY(5px)`,
                          }}
                        />{" "}
                        Home
                      </Link>
                    </BreadcrumbItem>
                  </Breadcrumb>
                  <H1>Treatments</H1>
                  <Subtitle>
                    <Trier>Sort by:</Trier>
                    <Selector>
                      <StyledLink to="/en/treatments-by-concerns/">
                        Concerns
                      </StyledLink>
                      &nbsp;|&nbsp;
                      <StyledLink to="/en/treatments/">Body regions</StyledLink>
                      &nbsp;| Procedures
                    </Selector>
                  </Subtitle>
                </Col>
              </Row>
            </Container>
          </WhiteRow>

          <WhiteRow>
            <Container>
              <H2>
                <Link {...cssLinkTitle} to="/en/botox-injections/">
                  Botox injection
                </Link>
              </H2>
              <Row>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/face/bruxism-teeth-grinding/">
                    Bruxism: Teeth grinding treatment
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/face/jaw-reduction-botox/">
                    Jaw reduction using Botox
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/face/botox-for-migraine/">
                    Migraine
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/eyes/botox-crows-feet/">
                    Crow's feet
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/face/neck-rejuvenation-botox/">
                    Neck rejuvenation
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/eyes/forehead-lift/">
                    Forehead lift
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/face/forehead-wrinkles-botox/">
                    Forehead wrinkles
                  </Link>
                </Col>
              </Row>
            </Container>
          </WhiteRow>
          <GreyRow>
            <Container>
              <H2>
                <Link {...cssLinkTitle} to="/en/fat-removal/">
                  Fat removal
                </Link>
              </H2>
              <Row>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/body-contouring/body-lift/">
                    Body lift
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/en/body-contouring/cryolipolysis-coolsculpting/"
                  >
                    Coolsculpting
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/body-contouring/emsculpt/">
                    EMSculpt
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/body-contouring/keybody-lipo/">
                    Keybody-Lipo
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/body-contouring/liposuction/">
                    Liposuction
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/en/body-contouring/xbody-reshape-body-ems/"
                  >
                    XBody
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/body-contouring/consultation/">
                    Body contouring diagnostic consultation
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/face/double-chin-removal/">
                    Double chin
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/en/body-contouring/keybody-cellulite/"
                  >
                    Keybody-Cellulite
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/arms/arm-liposuction/">
                    Arm liposuction
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/legs/calf-liposuction/">
                    Calf liposuction
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/face/face-neck-liposuction/">
                    Face and neck liposuction
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/en/local-anesthesia-cosmetic-surgery/#liposuccion-douce"
                  >
                    Gentle liposuction
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/en/body-contouring/saddlebags-liposuction/"
                  >
                    Saddlebags liposuction
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/body-contouring/mommy-makeover/">
                    Mommy makeover
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/body-contouring/onda-coolwaves/">
                    ONDA Coolwaves
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/face/jowls-fat-removal/">
                    Remove jowls
                  </Link>
                </Col>
              </Row>
            </Container>
          </GreyRow>
          <WhiteRow>
            <Container>
              <Row>
                <Col>
                  <H2>
                    <Link {...cssLinkTitle} to="/en/hyaluronic-acid/">
                      Hyaluronic acid
                    </Link>
                  </H2>
                </Col>
              </Row>
              <Row>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/face/hyaluronic-acid-wrinkles/">
                    Correction of wrinkles
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/genital/g-spot-amplification/">
                    G-Spot Amplification
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/face/skinbooster/">
                    Skinboosters
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/en/under-eye-circles/hyaluronic-acid-under-eye-circles/"
                  >
                    Under-eye circles filling
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/face/ellanse/">
                    ELLANSÉ®
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/face/hydrafacial/">
                    HydraFacial
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/face/mesolift-nctf/">
                    Mesolift NCTF
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/nose/non-surgical-rhinoplasty/">
                    Non-surgical rhinoplasty
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/en/face/forehead-wrinkles-hyaluronic-acid/"
                  >
                    Forehead wrinkles
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/news/sisthaema/">
                    Sisthaema
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/face/lip-aesthetic-treatment/">
                    Lip aesthetic treatments
                  </Link>
                </Col>
              </Row>
            </Container>
          </WhiteRow>
          <GreyRow>
            <Container>
              <Row>
                <Col>
                  <H2>
                    <Link {...cssLinkTitle} to="/en/implants/">
                      Implants
                    </Link>
                    /{" "}
                    <Link {...cssLinkTitle} to="/en/lipotransfer/">
                      Lipofilling
                    </Link>
                  </H2>
                </Col>
              </Row>
              <Row>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/breast/breast-lipofilling/">
                    Breast Lipofilling
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/breast/breast-implants/">
                    Breast implants
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/en/body-contouring/buttock-plastic-surgery/"
                  >
                    Buttock plastic surgery
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/en/ears/earfold-prominent-ears-treatment/"
                  >
                    EarFold implants
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/en/genital/labiaplasty-labia-reduction/"
                  >
                    Labiaplasty
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/en/under-eye-circles/under-eye-circles-lipofilling/"
                  >
                    Under-eye circles lipofilling
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/face/lip-aesthetic-treatment/">
                    Lip lipofilling
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/legs/calf-lipofilling/">
                    Calf lipofilling
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/en/breast/macrolane-breast-augmentation/"
                  >
                    Macrolane
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/breast/motiva-preserve/">
                    Motiva Preserve
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/legs/calf-implants/">
                    Calf implants
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/body-contouring/buttock-implants/">
                    Buttock implants
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/genital/g-spot-amplification/">
                    G-Spot Amplification
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/breast/breast-implant-removal/">
                    Breast implant removal
                  </Link>
                </Col>
              </Row>
            </Container>
          </GreyRow>

          <WhiteRow>
            <Container>
              <H2>
                <Link {...cssLinkTitle} to="/en/plastic-surgery/">
                  Plastic surgery
                </Link>
              </H2>
              <Row>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/en/before-after/adipomastia-gynecomastia/"
                  >
                    Adipomastia - Gynecomastia
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/breast/breast-reduction/">
                    Breast reduction
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/en/eyes/blepharoplasty-eyelid-surgery/"
                  >
                    Blepharoplasty: Eyelid surgery
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/body-contouring/body-lift/">
                    Body lift
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/en/body-contouring/buttock-plastic-surgery/"
                  >
                    Buttock plastic surgery
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/nose/rhinoplasty/">
                    Rhinoplasty
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/nose/septoplasty/">
                    Septoplasty
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/nose/septoplasty/">
                    Deviated nasal septum correction
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/en/ears/otoplasty-prominent-ears-surgery/"
                  >
                    Prominent Ear surgery
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/en/ears/otoplasty-prominent-ears-surgery/"
                  >
                    Otoplasty
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/breast/breast-implants/">
                    Breast augmentation
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/en/eyes/double-eyelid-asian-blepharoplasty/"
                  >
                    Asian blepharoplasty
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/en/under-eye-circles/lower-blepharoplasty/"
                  >
                    Lower blepharoplasty
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/en/local-anesthesia-cosmetic-surgery/"
                  >
                    Surgery under local anesthesia
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/face/chin-surgery-genioplasty/">
                    Chin surgery (Genioplasty)
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/breast/breast-lipofilling/">
                    Breast lipofilling
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/body-contouring/mommy-makeover/">
                    Mommy makeover
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/breast/motiva-preserve/">
                    Motiva Preserve
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/body-contouring/tummy-tuck/">
                    Tummy tuck
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/breast/breast-lift/">
                    Breast lift
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/nose/ethnic-rhinoplasty/">
                    Ethnic rhinoplasty
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/nose/revision-rhinoplasty/">
                    Revision rhinoplasty
                  </Link>
                </Col>
              </Row>
            </Container>
          </WhiteRow>

          <GreyRow>
            <Container>
              <Row>
                <Col>
                  <H2>
                    <Link {...cssLinkTitle} to="/en/reconstructive-surgery/">
                      Reconstructive surgery
                    </Link>
                  </H2>
                </Col>
              </Row>
              <Row>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/breast/breast-lift/">
                    Breast lift
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/en/breast/breast-reconstruction-surgery/"
                  >
                    Breast Reconstruction surgery
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/arms/carpal-tunnel-syndrome/">
                    Carpal tunnel syndrome
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/arms/decompression-ulnar-nerve/">
                    Decompression of the ulnar nerve
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/en/ears/split-torn-stretched-earlobe-surgery/"
                  >
                    Earlobe surgery
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/arms/carpal-tunnel-syndrome/">
                    Median nerve decompression
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/skin/scar-revision/">
                    Scar revision
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/body-contouring/body-lift/">
                    Bodylift
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/nose/septoplasty/">
                    Deviated nasal septum correction
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/en/ears/earfold-prominent-ears-treatment/"
                  >
                    EarFold
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/face/botox-for-migraine/">
                    Migraine
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/en/genital/labiaplasty-labia-reduction/"
                  >
                    Nymphoplasty
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/en/ears/otoplasty-prominent-ears-surgery/"
                  >
                    Otoplasty
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/en/body-contouring/gynecomastia-male-breast/"
                  >
                    Male breast (Gynecomastia)
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/skin/skin-tumor-surgery/">
                    Skin tumors
                  </Link>
                </Col>
              </Row>
            </Container>
          </GreyRow>

          <WhiteRow>
            <Container>
              <H2>
                <Link {...cssLinkTitle} to="/en/skin/">
                  Skin treatments
                </Link>
              </H2>
              <Row>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/en/skin/biorevitalization-peel-prx-t33/"
                  >
                    Biorevitalization Peel PRX-T33
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/face/crows-feet-chemical-peel/">
                    Chemical peel for crow's feet
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/face/face-treatment-diagnosis/">
                    Diagnosis for face treatments
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/face/hydrafacial/">
                    HydraFacial
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/skin/keybody-skin/">
                    Keybody-Skin
                  </Link>
                </Col>

                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/en/skin/laser-icon-skin-imperfections/"
                  >
                    Laser Icon
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/face/mesolift-nctf/">
                    Mesolift NCTF
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/face/skinbooster/">
                    Skinbooster
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/skin/ultraclear-laser/">
                    UltraClear laser
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/face/carboxytherapy/">
                    Facial carboxytherapy
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/face/face-treatment-diagnosis/">
                    Diagnosis for face treatments
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/en/face/rosacea-redness-laser-treatment/"
                  >
                    Rosacea and redness
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/face/silhouette-soft-thread-lift/">
                    Thread lift
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/skin/lasemd-ultra/">
                    LaseMD Ultra
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/body-contouring/onda-coolwaves/">
                    ONDA Coolwaves
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/face/combined-peel/">
                    Combined peel
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/en/under-eye-circles/pigmented-under-eye-circles-peel/"
                  >
                    Under-eye circles depigmenting peel
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/skin/dynamic-phototherapy/">
                    Dynamic phototherapy
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/skin/platelet-rich-plasma-prp/">
                    Platelet-Rich Plasma (PRP)
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/eyes/plexr/">
                    Plexr®
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/news/sisthaema/">
                    Sisthaema
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/en/body-contouring/keybody-cellulite/"
                  >
                    Cellulite treatment
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/face/universkin/">
                    Universkin: Medical cosmetics
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/skin/stretch-marks/">
                    Stretch marks
                  </Link>
                </Col>
              </Row>
            </Container>
          </WhiteRow>
          <GreyRow css={{ paddingBottom: `6em` }}>
            <Container>
              <Row>
                <Col>
                  <H2>
                    <Link {...cssLinkTitle} to="/en/lifts/">
                      Surgical lifts
                    </Link>
                  </H2>
                </Col>
              </Row>
              <Row>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/arms/arm-lift/">
                    Arm Lift
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/breast/breast-lift/">
                    Breast lift
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/face/facelift-lvpa/">
                    Facelift LVPA
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/face/deep-plane-facelift/">
                    Deep Plane Facelift
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/body-contouring/tummy-tuck/">
                    Tummy Tuck
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/en/eyes/blepharoplasty-eyelid-surgery/"
                  >
                    Blepharoplasty
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/body-contouring/body-lift/">
                    Bodylift
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/legs/thigh-lift/">
                    Thigh lift
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/face/neck-lift-platysmaplasty/">
                    Neck lift - Platysmaplasty
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/eyes/forehead-lift/">
                    Forehead lift
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/face/cervicofacial-facelift/">
                    Cervicofacial facelift
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/en/under-eye-circles/cheek-lift-under-eye-circles/"
                  >
                    Cheek lift
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/en/local-anesthesia-cosmetic-surgery/#mini-lift"
                  >
                    Mini-lift
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/en/body-contouring/mommy-makeover/">
                    Mommy makeover
                  </Link>
                </Col>
              </Row>
            </Container>
          </GreyRow>
        </main>
        <Footer />
      </g.Div>
    </Layout>
  );
}
